/**
 * Returns the asset data, overridden with the default asset data if a variant in a strategy is passed.
 * @param assetData - Data for the asset being viewed in the content editor
 * @param defaultAsset - The default asset for the strategy of the asset being viewed in the content editor
 * @returns The asset data, overridden with the default asset data if applicable
 */
export const getAssetDataWithDefaultOverride = (assetData, defaultAsset) => {
  var _defaultAsset$assetDa, _defaultAsset$assetDa2, _defaultAsset$assetCo;
  const isDefaultAsset = assetData.assetId.toString() === (defaultAsset === null || defaultAsset === void 0 ? void 0 : defaultAsset.assetCoordinates.id.toString());
  if (!assetData.strategyId || isDefaultAsset) {
    return assetData;
  }
  return {
    assetType: assetData.assetType,
    strategyId: assetData.strategyId,
    assetName: (_defaultAsset$assetDa = defaultAsset === null || defaultAsset === void 0 || (_defaultAsset$assetDa2 = defaultAsset.assetData) === null || _defaultAsset$assetDa2 === void 0 ? void 0 : _defaultAsset$assetDa2.name) !== null && _defaultAsset$assetDa !== void 0 ? _defaultAsset$assetDa : '',
    assetId: (_defaultAsset$assetCo = defaultAsset === null || defaultAsset === void 0 ? void 0 : defaultAsset.assetCoordinates.id) !== null && _defaultAsset$assetCo !== void 0 ? _defaultAsset$assetCo : ''
  };
};